var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgApple = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "a",
  width: 24,
  height: 24,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0V0Z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#0E0E0E",
  d: "M18.893 8.707c-.111.087-2.065 1.198-2.065 3.669 0 2.857 2.486 3.868 2.56 3.893-.011.062-.394 1.384-1.31 2.733-.817 1.186-1.67 2.37-2.967 2.37-1.297 0-1.63-.76-3.128-.76-1.46 0-1.979.785-3.165.785-1.187 0-2.015-1.097-2.967-2.446-1.103-1.582-1.994-4.041-1.994-6.375 0-3.744 2.412-5.729 4.785-5.729 1.261 0 2.312.836 3.104.836.754 0 1.929-.886 3.364-.886.543 0 2.496.05 3.783 1.91Zm-4.465-3.495c.594-.71 1.013-1.696 1.013-2.682 0-.137-.011-.275-.036-.387-.965.036-2.114.649-2.806 1.46-.544.624-1.051 1.61-1.051 2.609 0 .15.025.3.036.348.061.012.16.025.26.025.865 0 1.955-.585 2.584-1.373Z"
}))));
export default SvgApple;